module.exports = __webpack_public_path__ + "img/newsImg.cc21ba5d.png";